import React, { FunctionComponent } from 'react';
import styled from 'styled-components/macro';
import Footer from '../components/footer/Footer';
import { History } from 'history';
import Header from '../components/header/Header';
import { DeviceSize } from '../components/basic/DeviceSize';
//import { hasExpiringAgreement } from '../utils';
import Breadcrumbs from '../components/Breadcrumbs';
import { useLocation } from 'react-router';
import { useApp } from '../context/appContext';
import { MenuItem } from '../types/wordpress';
//import { Slugs } from '../constants/knownSlugs';
import { theme } from '../theme';
import Notifications from '../components/Notifications';
import Bulletins from '../components/bulletin/Bulletins';

const Container = styled.div`
  position: relative;
  background: ${theme().colors.m2White};

  @media print {
    background: none;
  }
`;

const Content = styled.div`
  min-height: 50vh;
  width: 100%;
  position: relative;

  @media ${DeviceSize.desktopS} {
    margin-top: 20px;
  }

  @media print {
    margin-top: 0px;
  }
`;

const PageContainer: FunctionComponent<{ history: History }> = ({ history, children }) => {
  const [{ menu }] = useApp();
  const { pathname } = useLocation();
  const isHome = pathname === '/';

  // const hideOnExpiredAgreement = [Slugs.BOOKINGS];
  // const hideOnExpiredAgreementSubMenu = [
  //   // My Building
  //   Slugs.BUILDING_INFO,
  //   Slugs.GUIDES_DOCUMENTS,
  //   Slugs.NOTICES,
  //   Slugs.EVENTS,
  //   // Living
  //   Slugs.WORK,
  //   Slugs.INFLUENCERS,
  //   Slugs.EVENTS_FOR_ALL,
  //   Slugs.APARTMENT_CHANGE,
  //   Slugs.COMMITTEE,
  //   Slugs.CHAIRMAN,
  // ];

  const shouldShowSubMenuItem = (slug: string) => {
    // const isHiddenDueToMissingWatermeter =
    //   slug === Slugs.WATER_METER && apartment.info.waterMeter !== 'Huoneistokohtainen vesimittari';

    // const isHiddenDueToExpiredAgreement =
    //   hideOnExpiredAgreementSubMenu.some((item) => item === slug) && hasExpiringAgreement(user);

    // return !(isHiddenDueToMissingWatermeter || isHiddenDueToExpiredAgreement);
    return true; // This is temporary, until we get water meter and expiring agreement info from Kenno
  };

  const shouldShowMenuItem = (slug: string) => {
    // const isHiddenDueToMissingCalendar = slug === Slugs.BOOKINGS && !modules.modules?.length;

    // const isHiddenDueToExpiredAgreement =
    //   hideOnExpiredAgreement.some((item) => item === slug) && hasExpiringAgreement(user);

    // return !(isHiddenDueToMissingCalendar || isHiddenDueToExpiredAgreement);
    return true; // This is temporary, until we get bookings and expiring agreement info from Kenno
  };

  const filteredMenuItems: MenuItem[] = [];
  // Apply filtering to the menu items and their children
  menu.items.forEach((menuItem) => {
    if (shouldShowMenuItem(menuItem.slug)) {
      // Apply child item filtering
      const filteredChildren = menuItem.children.filter((child) => shouldShowSubMenuItem(child.slug));
      filteredMenuItems.push({
        ...menuItem,
        children: filteredChildren,
      });
    }
  });

  return (
    <Container className="pageContent">
      <Bulletins />
      <Header history={history} menuItems={filteredMenuItems} />
      {!isHome && <Breadcrumbs />}
      <div className="content">
        <Content>{children}</Content>
        <Footer menuItems={filteredMenuItems} />
        <Notifications />
      </div>
    </Container>
  );
};

export default PageContainer;
